import React from "react";
import styled from "styled-components";
import { SCREEN_SM } from "../theme";
import { NotDataView } from "./notDataView";
const SytledWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
`;

const StyledContentDiv = styled.div`
  width: 100%;

  margin-top: 0;
  margin-left: 0;
  padding: 0 0 calc(20%) 0px;
  border-radius: 0;

  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  @media (max-width: ${SCREEN_SM}) {
    width: 100%;
    padding: 0.2rem 0.2rem;
  }
`;

export interface NotFoundProps {}
export const NotFoundPage: React.FC<NotFoundProps> = ({}) => {
  return (
    <SytledWrapper>
      <StyledContentDiv>
        <NotDataView
          title="404"
          subTitle="页面未找到"
          detail={
            "很抱歉,您访问的页面不存在或已被删除。\n你可以返回主页继续浏览"
          }
          url="/"
          urlText="主页"
        ></NotDataView>
      </StyledContentDiv>
    </SytledWrapper>
  );
};
